import TrouvilleJanuary2026 from "../../components/before-after/TrouvilleJanuary2026";

const TrouvilleJanuary2026View = () => {

    return (
        <div className="before-after-trouville-january-2026">
            <TrouvilleJanuary2026/>
        </div>
    );
};

export default TrouvilleJanuary2026View;